// import useSearchMembers from '@/contexts/chat/scripts/hooks/useSearchMembers';
import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import classes from './index.module.scss';

type Member = ChatGroupMember;

// type SearchCommonType = 'global' | 'contacts' | 'chat';

interface SearchCommonProps<T> {
  value?: string;
  multiple?: boolean;
  keyValue?: keyof T;
  type?: 'global' | 'contacts' | 'chat';
  title?: string;
  onSelect: (item: T[]) => void;
  selectedList?: T[];
  list: T[];
  // setCheckedList: (item: T[]) => void;
}

export default function SearchCommon<T extends Member>({
  // value,
  // type = 'global',
  multiple = true,
  keyValue = 'user_id' as keyof T,
  title = 'Members in global',
  onSelect,
  selectedList = [],
  list,
  // setCheckedList,
}: SearchCommonProps<T>) {
  // const { list } = useSearchMembers<T>({ value, type });
  // const [checkedList, setCheckedList] = useState<T[]>(selectedList || []);

  const handleClick = useCallback(
    (item: T) => {
      const isSelected = selectedList?.some((c) => c[keyValue] === item[keyValue]);
      if (isSelected) {
        onSelect(selectedList?.filter((c) => c[keyValue] !== item[keyValue]));
      } else {
        if (multiple) {
          onSelect([...selectedList, item]);
        } else {
          onSelect([item]);
        }
      }
    },
    [selectedList, keyValue, onSelect, multiple]
  );

  return (
    <div className={classes.searchCommon}>
      {list.length > 0 && <div className={classes.title}>{title}</div>}
      {list.map((item) => (
        <MemberItem
          key={item[keyValue] as string}
          hoverable={true}
          avatarProps={{ src: item.avatar, info: item }}
          name={item.name}
          shortName={item.username}
          checked={selectedList.some((c) => c[keyValue] === item[keyValue])}
          showCheck={true}
          onClick={() => handleClick(item)}
        />
      ))}
    </div>
  );
}
